import { render, staticRenderFns } from "./noticias.vue?vue&type=template&id=96d8bf3a&scoped=true&"
import script from "./noticias.vue?vue&type=script&lang=js&"
export * from "./noticias.vue?vue&type=script&lang=js&"
import style0 from "./noticias.vue?vue&type=style&index=0&id=96d8bf3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8bf3a",
  null
  
)

export default component.exports